import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import { Alert, Box, Button, Container, Divider, IconButton, MobileStepper, Typography, useTheme } from '@mui/material';
import Grid from '@mui/material/Grid2'; // Using GridV2
import React from 'react';
import "../../App.css";
import { AppBarPadding, BottomPadding } from '../../utils/helperUtils';
import { useNavigate } from "react-router-dom";
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { theme } from "../../theme";

const formMidWith = {
    xs: 350,
    sm: 600,
    md: 800
}

function CreateEditFormComponent({
    bgColor,
    title,
    titleColor,
    error,
    setError,
    formBgColor,
    children,
    maxSteps,
    activeStep,
    validateStep,
    slug,
    handleBack,
    handleNext,
    handleSubmit,
    handleUpdate,
    dividerColor,
    backStepperColor,
    
}) {

    const themeX = useTheme();
    const navigate = useNavigate();
    
    return (
        <Box className="create-edit-box-container" bgcolor={bgColor}>
            <Container maxWidth="lg">
                <AppBarPadding />
                <Grid container justifyContent={'center'}>
                    <Grid>
                        {/* <Typography fontSize={30} color={titleColor}>
                            <Box sx={{ fontWeight: 'bold', mb: 1 }}>
                                {title}
                            </Box>
                        </Typography> */}
                        <Box display="flex" alignItems="center" mb={1}>
                            {slug &&
                                <IconButton
                                    size='small'
                                    onClick={() => navigate(-1)}
                                    sx={{
                                        color: titleColor,
                                        border: `1px solid ${titleColor}`,
                                        borderRadius: 3,
                                        mr: 1
                                    }}
                                >
                                    <ArrowBackIosNewIcon />
                                </IconButton>
                            }
                            <Typography fontSize={30} color={titleColor} textAlign={'left'}>
                                <Box sx={{ fontWeight: 'bold' }}>
                                    {title}
                                </Box>
                            </Typography>
                        </Box>
                        <Divider sx={{ borderBottomWidth: 2, bgcolor: dividerColor || bgColor }} />
                        {error && (
                            <Grid size={{ xs: 12 }} mt={1}>
                                <Alert severity="error" onClose={() => setError(null)}>
                                    {error}
                                </Alert>
                            </Grid>
                        )}
                        <Box
                            sx={{
                                mt: 2,
                                bgcolor: formBgColor
                            }}
                            borderRadius={4}
                            minWidth={formMidWith}
                        >
                            {children}

                            {/* Mobile Stepper Navigation */}
                            <MobileStepper
                                variant="text"
                                sx={{
                                    borderBottomLeftRadius: 15,
                                    borderBottomRightRadius: 15,
                                    bgcolor: formBgColor,
                                    color: bgColor,
                                    pb: 2
                                }}
                                steps={maxSteps}
                                position="static"
                                activeStep={activeStep}

                                nextButton={
                                    <Box
                                        sx={activeStep === maxSteps - 1 && {
                                            bgcolor: bgColor,
                                            borderRadius: 3
                                        }}>
                                        <Button
                                            size="small"
                                            onClick={activeStep === maxSteps - 1 ? (slug ? handleUpdate : handleSubmit) : handleNext}
                                            sx={{ color: activeStep === maxSteps - 1 ? titleColor : bgColor }}
                                            disabled={!validateStep()}
                                        >
                                            {activeStep === maxSteps - 1 ? (slug ? "Update" : "Save") : "Next"}
                                            {activeStep !== maxSteps - 1 && (themeX.direction === "rtl" ? <KeyboardArrowLeft /> : <KeyboardArrowRight />)}
                                        </Button>
                                    </Box>

                                }
                                backButton={
                                    <Button size="small" onClick={handleBack} disabled={activeStep === 0}
                                        sx={{ color: backStepperColor || titleColor }}
                                    >
                                        {themeX.direction === "rtl" ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
                                        Back
                                    </Button>
                                }
                            />
                        </Box>
                    </Grid>
                </Grid>
                <BottomPadding />
            </Container>
        </Box>
    )
}

CreateEditFormComponent.defaultProps = {
    bgColor: "#fff",
    dividerColor: null,
    backStepperColor: null,
    title: "Untitled Form",
    titleColor: "#000",
    error: null,
    setError: () => {},
    formBgColor: "#f5f5f5",
    children: null,
    maxSteps: 1,
    activeStep: 0,
    validateStep: () => true,
    slug: null,
    handleBack: () => {},
    handleNext: () => {},
    handleSubmit: () => {},
    handleUpdate: () => {},
};

export default CreateEditFormComponent